module.exports = {
      id: "strategy-usage",
      viewBox: "0 0 13.247 22.012",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#strategy",
      toString: function () {
        return this.url;
      }
    }